import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyDa = () => {
    return <PrivacyPolicy languageCode="da" />
}

export default PrivacyPolicyDa
